var _circle, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommissionAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#B2E3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3665 38.0905C42.6215 38.0905 41.6346 38.074 40.406 38.074C37.4098 38.074 34.946 35.5941 34.946 32.5696V27.2632C34.946 26.8458 34.6129 26.5059 34.1994 26.5059H25.4719C21.399 26.5059 18.1069 29.8488 18.1069 33.9457V51.7245C18.1069 56.0227 21.5558 59.5059 25.8117 59.5059H38.8083C42.8665 59.5059 46.1569 56.1844 46.1569 52.0842V38.833C46.1569 38.4139 45.8253 38.0757 45.4103 38.0773C44.7127 38.0823 43.8761 38.0905 43.3665 38.0905Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1392 42.8386H36.1219C36.8 42.8386 37.3511 43.388 37.3511 44.0662C37.3511 44.7443 36.8 45.2954 36.1219 45.2954H27.1392C26.4611 45.2954 25.9116 44.7443 25.9116 44.0662C25.9116 43.388 26.4611 42.8386 27.1392 42.8386Z",
    fill: "#94CDE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0245 49.4293H27.1392C26.4611 49.4293 25.9116 49.9788 25.9116 50.6569C25.9116 51.3351 26.4611 51.8862 27.1392 51.8862H36.0245C36.7027 51.8862 37.2538 51.3351 37.2538 50.6569C37.2538 49.9788 36.7027 49.4293 36.0245 49.4293Z",
    fill: "#94CDE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.1426,
    y: 21.6421,
    width: 22,
    height: 17,
    rx: 4,
    fill: "#B2E3F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1383 27.6057L54.3378 18.0553L37.3695 18.3291L37.17 27.8795L54.1383 27.6057Z",
    fill: "#B2E3F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0286 28.9391L38.0286 28.9417C38.0342 29.2004 38.1432 29.4354 38.3171 29.6037C38.4905 29.7717 38.7296 29.8743 38.9901 29.8701L57.9285 29.5645L57.9287 29.5645C58.4509 29.556 58.868 29.1253 58.8595 28.603L58.6966 18.5025C58.6882 17.9802 58.2574 17.5631 57.7351 17.5715L38.7966 17.877C38.2743 17.8854 37.8572 18.3162 37.8656 18.8385L38.0286 28.9391ZM39.9065 27.9622L39.7741 19.7542L56.82 19.4792L56.9524 27.6872L39.9065 27.9622Z",
    fill: "#3E96BC",
    stroke: "#3E96BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.012 35.3882L52.2019 24.8601L33.3695 23.3291L34.1796 33.8571L53.012 35.3882Z",
    fill: "#B2E3F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7429 34.2965L33.743 34.2991C33.7485 34.5578 33.8576 34.7928 34.0314 34.9612C34.2049 35.1291 34.444 35.2317 34.7044 35.2275L53.6429 34.922L53.643 34.922C54.1652 34.9134 54.5823 34.4827 54.5739 33.9604L54.4109 23.8599C54.4025 23.3376 53.9717 22.9205 53.4494 22.9289L34.511 23.2344C33.9887 23.2429 33.5715 23.6737 33.58 24.196L33.7429 34.2965ZM35.6208 33.3197L35.4884 25.1117L52.5343 24.8367L52.6668 33.0447L35.6208 33.3197Z",
    fill: "#3E96BC",
    stroke: "#3E96BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8059 27.3294C44.3467 27.3364 43.9876 27.6157 43.7689 27.98L43.7686 27.9805C43.5734 28.3064 43.4832 28.7057 43.4895 29.101C43.4978 29.6351 43.6808 30.1503 44.0251 30.4836C44.2394 30.6911 44.5275 30.8352 44.8619 30.8299C44.862 30.8299 44.8621 30.8299 44.8622 30.8299L44.8564 30.4733L44.8567 30.4733C45.2355 30.4672 45.4852 30.1849 45.6098 29.9662C45.7502 29.7196 45.8277 29.4049 45.8223 29.0643L44.8059 27.3294ZM43.8464 29.0956C43.8518 29.4363 43.9394 29.7484 44.0877 29.9903C44.1342 30.0663 44.1967 30.1498 44.2749 30.2256C44.4173 30.3639 44.6117 30.4769 44.8561 30.4733L44.8564 30.4733L43.8464 29.0956Z",
    fill: "#3E96BC",
    stroke: "#3E96BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionAmount);
export default __webpack_public_path__ + "static/media/commissionAmount.30294b0bd6c76a34e2b295734d5b8200.svg";
export { ForwardRef as ReactComponent };